

















import { Component, Vue } from "vue-property-decorator";

@Component
export default class Video extends Vue {
  onclickVideo(): void {
    this.$store.state.srcVideo = "https://www.youtube.com/embed/Vb1DGzDrCaY";
    this.$store.state.closePopUp = false;
  }
}
